<ng-template #cardModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title" >Add Card for Customer {{ selectedcust.name }}</h4>
		<button type="button" mat-icon-button aria-label="Close" (click)="modal.dismiss('Cross click')">
			<mat-icon>close</mat-icon>
		</button>
	</div>
	<div class="modal-body text-dark">
		<app-credit-card-form [customer]="selectedcust" [branches]="customerdata?.branches || []" [type]="'orderentry'" [arpreauth]="arpreauth" (updatePayments)="attachCard($event)" class="w-100"></app-credit-card-form>
</div>
	<div class="modal-footer">		
	</div>
</ng-template>
<div class="main-content">
    <div class="container-fluid">
        <div class="row tp-wrapper m-0 p-0">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-{{color}}-6">
                        <h4 class="card-title" (click)="back()">
                            <i class="material-icons">arrow_left</i>
                            Payment by Term - Batch Processing
                        </h4>
                    </div>
                    <div class="card-body">
                        <div class="row mb-3 align-items-end">
                            <div class="col-md-5 mb-2">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>Payment Terms</mat-label>
                                    <mat-select [(ngModel)]="selectedTermCodes" multiple appSelectAll
                                        [disabled]="termsLoading || loading">
                                        <mat-option *ngFor="let term of availableTerms" [value]="term.termsindicator">
                                            {{ term.terms }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <div *ngIf="availableTerms.length === 0 && !termsLoading"
                                    class="text-muted small mt-1">
                                    No payment terms found with collect_payment enabled
                                </div>
                            </div>
                            <div class="col-md-3 mb-2">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>Aging Bucket</mat-label>
                                    <mat-select [(ngModel)]="agingBucket" [disabled]="loading || previewLoading">
                                        <mat-option *ngFor="let bucket of agingBuckets" [value]="bucket.value">
                                            {{ bucket.label }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-md-2 mb-2 d-flex align-items-center">
                                <button class="btn btn-primary btn-sm" mat-raised-button
                                    [disabled]="loading || previewLoading || selectedTermCodes.length === 0"
                                    (click)="loadCustomersByTerms()">
                                    <mat-icon>visibility</mat-icon>
                                    Load Customers
                                </button>
                            </div>
                            <div class="col-md-2 mb-2 d-flex align-items-center">
                                <button class="btn btn-secondary btn-sm" mat-raised-button [disabled]="loading"
                                    (click)="loadBatchHistory()" *ngIf="!loading">
                                    Refresh
                                </button>
                                <span *ngIf="termsLoading || previewLoading || processing" class="ml-2 d-flex align-items-center">
                                    <svg class="spinner" width="20px" height="20px" viewBox="0 0 66 66"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33"
                                            cy="33" r="30"></circle>
                                    </svg>
                                    <small class="ml-1">
                                        <ng-container *ngIf="termsLoading">Loading terms...</ng-container>
                                        <ng-container *ngIf="previewLoading">Loading customers...</ng-container>
                                        <ng-container *ngIf="processing">Processing...</ng-container>
                                    </small>
                                </span>
                            </div>
                        </div>
                        
                            <!-- Review & Process header (always present; buttons disabled until customers exist) -->
                            <div class="col-md-12">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <div>
                                        <h5 class="mb-1">Review & Process Payments</h5>
                                        <div class="text-muted small">
                                            <strong>Selected:</strong> {{ getSelectedCount() }} of
                                            {{ previewCustomers.length }}
                                            &nbsp;|&nbsp;
                                            <strong>Total to charge:</strong>
                                            {{ formatCurrency(getSelectedTotalAmount()) }}
                                        </div>
                                    </div>
                                    <div>
                                        <button class="mt-2 mr-2" mat-raised-button color="accent"
                                            [disabled]="processing || getSelectedCount() === 0"
                                            (click)="processSelectedCustomers()">
                                            Process Payments ({{ getSelectedCount() }})
                                        </button>
                                        <button class="mt-2" mat-raised-button color="primary" [disabled]="processing"
                                            (click)="cancelPreview()">
                                            Cancel
                                        </button>
                                    </div>
                                    <!-- Details table only when customers loaded -->
                                    <div class="table" *ngIf="previewCustomers.length > 0">
                                        <div class="bg-white mt-2 rounded">
                                            <div id="previewCustomers" class="table-responsive">
                                                <table class="table table-fixed collapsed">
                                                    <thead>
                                                        <tr>
                                                            <th class="text-center" style="width: 50px;">
                                                                <input type="checkbox"
                                                                    [checked]="selectedCustomers.size === previewCustomers.length"
                                                                    (change)="selectedCustomers.size === previewCustomers.length ? deselectAllCustomers() : selectAllCustomers()">
                                                            </th>
                                                            <th class="text-left">Customer</th>
                                                            <th class="text-left">Payment Terms</th>
                                                            <th class="text-right">Total Balance</th>
                                                            <th class="text-right">Overdue
                                                                ({{ agingBucket === 'overdue1' ? '30+' : (agingBucket === 'overdue2' ? '60+' : '90+') }}
                                                                days)</th>
                                                            <th class="text-center">Card</th>
                                                            <th class="text-right">Amount to Charge</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let customer of previewCustomers"
                                                            [class.bg-light]="!customer.selected">
                                                            <td class="text-center">
                                                                <input type="checkbox" [checked]="customer.selected"
                                                                    (change)="toggleCustomer(customer)">
                                                            </td>
                                                            <td class="text-left">
                                                                <strong>{{ customer.debtorno }}.{{ customer.branchcode }}</strong><br>
                                                                <small>{{ customer.name }}</small>
                                                            </td>
                                                            <td class="text-left">
                                                                {{ customer.payment_term_name || customer.payment_term_code }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ formatCurrency(customer.total_balance) }}
                                                            </td>
                                                            <td class="text-right">
                                                                <strong>{{ formatCurrency(customer.overdue_balance) }}</strong>
                                                                <small
                                                                    class="d-block text-muted">({{ customer.overdue_invoices?.length || 0 }}
                                                                    invoices)</small>
                                                            </td>
                                                            <td class="text-center">
																<button class="btn btn-sm btn-primary" (click)="addCard(customer)"><mat-icon>add</mat-icon></button>
                                                                <select class="form-control form-control-sm"
                                                                    [disabled]="!customer.selected || !customer.cards || customer.cards.length === 0"
                                                                    [(ngModel)]="customer.selectedCardId">
                                                                    <option *ngFor="let card of customer.cards"
                                                                        [value]="card.card_id">
                                                                        {{ getCardDisplay(card) }}
                                                                    </option>
                                                                </select>
                                                            </td>
                                                            <td class="text-right">
                                                                <input type="number"
                                                                    class="form-control form-control-sm text-right"
                                                                    [disabled]="!customer.selected"
                                                                    [(ngModel)]="customer.amount" step="0.01" min="0"
                                                                    style="max-width: 120px; margin: 0 auto; display: block;">
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="previewCustomers.length === 0 && !previewLoading"
                                        class="text-center p-4">
                                        <p>No customers found.</p>
                                    </div>
                                </div>

                            </div>


                        </div>

                        <!-- Current Batch Status -->
                        <div class="row mb-4" *ngIf="currentBatch && currentBatch.status === 'running'">
                            <div class="col-12">
                                <div class="bg-warning p-3 rounded">
                                    <h5 class="mb-3">Currently Processing Batch #{{ currentBatch.id }}</h5>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <strong>Total Customers:</strong> {{ currentBatch.total_customers || 0 }}
                                        </div>
                                        <div class="col-md-3">
                                            <strong>Successful:</strong>
                                            <span
                                                class="badge badge-success">{{ currentBatch.successful_payments || 0 }}</span>
                                        </div>
                                        <div class="col-md-3">
                                            <strong>Failed:</strong>
                                            <span
                                                class="badge badge-danger">{{ currentBatch.failed_payments || 0 }}</span>
                                        </div>
                                        <div class="col-md-3">
                                            <strong>Total Amount:</strong>
                                            {{ formatCurrency(currentBatch.total_amount) }}
                                        </div>
                                    </div>
                                    <div class="mt-2">
                                        <button mat-raised-button color="accent"
                                            (click)="viewAttempts(currentBatch.id)">
                                            View Details
                                        </button>
                        </div>
                    </div>
                        </div>

                        <!-- Batch History -->
                        <div class="row" *ngIf="!loading">
                            <div class="col-md-12" id="batchHistory">
                                <ng-container *ngIf="batchHistory.length > 0">
                                    <div class="table">
                                        <div class="bg-white mt-2 rounded">
                                            <div id="batches" class="table-responsive">
                                                <table class="table compact table-sm table-fixed collapsed">
                                                    <thead>
                                                        <tr>
                                                            <th class="text-center">Batch ID</th>
                                                            <th class="text-center">Date</th>
                                                            <th class="text-center">Status</th>
                                                            <th class="text-center">Total Customers</th>
                                                            <th class="text-center">Successful</th>
                                                            <th class="text-center">Failed</th>
                                                            <th class="text-right">Total Amount</th>
                                                            <th class="text-center">Started</th>
                                                            <th class="text-center">Completed</th>
                                                            <th class="text-center donotprint">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let batch of batchHistory">
                                                            <td class="text-center">{{ batch.id }}</td>
                                                            <td class="text-center">{{ batch.batch_date }}</td>
                                                            <td class="text-center">
                                                                <span class="badge"
                                                                    [ngClass]="getStatusColor(batch.status)">
                                                                    {{ batch.status }}
                                                                </span>
                                                            </td>
                                                            <td class="text-center">{{ batch.total_customers }}</td>
                                                            <td class="text-center">
                                                                <span
                                                                    class="badge badge-success">{{ batch.successful_payments }}</span>
                                                            </td>
                                                            <td class="text-center">
                                                                <span
                                                                    class="badge badge-danger">{{ batch.failed_payments }}</span>
                                                            </td>
                                                            <td class="text-right">
                                                                {{ formatCurrency(batch.total_amount) }}</td>
                                                            <td class="text-center">{{ formatDate(batch.started_at) }}
                                                            </td>
                                                            <td class="text-center">{{ formatDate(batch.completed_at) }}
                                                            </td>
                                                            <td class="text-center donotprint">
                                                                <button class="btn btn-sm btn-info"
                                                                    (click)="viewAttempts(batch.id)">
                                                                    View Details
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="batchHistory.length === 0">
                                    <h4>No batch history found.</h4>
                                </ng-container>
                            </div>
                        </div>

                        <!-- Attempts Details -->
                        <div class="row mt-4" *ngIf="attempts.length > 0">
                            <div class="col-md-12">
                                <div class="table">
                                    <h3>Payment Attempts</h3>
                                    <div class="bg-white mt-2 rounded">
                                        <div id="attempts" class="table-responsive">
                                            <table class="table compact table-sm table-fixed collapsed">
                                                <thead>
                                                    <tr>
                                                        <th class="text-left">Customer</th>
                                                        <th class="text-center">Branch</th>
                                                        <th class="text-right">Amount</th>
                                                        <th class="text-center">Status</th>
                                                        <th class="text-center">Transaction ID</th>
                                                        <th class="text-center">Payment Trans #</th>
                                                        <th class="text-left">Error</th>
                                                        <th class="text-center">Attempted</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let attempt of attempts">
                                                        <td class="text-left">{{ attempt.debtorno }}</td>
                                                        <td class="text-center">{{ attempt.branchcode }}</td>
                                                        <td class="text-right">{{ formatCurrency(attempt.amount) }}</td>
                                                        <td class="text-center">
                                                            <span class="badge"
                                                                [ngClass]="getStatusBadgeClass(attempt.status)">
                                                                {{ attempt.status }}
                                                            </span>
                                                        </td>
                                                        <td class="text-center">{{ attempt.transaction_id || '-' }}</td>
                                                        <td class="text-center">{{ attempt.payment_transno || '-' }}
                                                        </td>
                                                        <td class="text-left">
                                                            <span *ngIf="attempt.error_message"
                                                                class="text-danger small">
                                                                {{ attempt.error_message }}
                                                            </span>
                                                            <span *ngIf="!attempt.error_message">-</span>
                                                        </td>
                                                        <td class="text-center">{{ formatDate(attempt.attempted_at) }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
